import {
  getCurrentCompletedQuestions,
  getCurrentCompletedQuizTotal,
} from './getCurrentCompletedQuiz'

export const getCompletedSteps = (
  questions: any,
  currentQuestionIndex: number,
  currentChoiceIndex: number,
): number[] => {
  if (!questions.length) return [0]

  const totalAmount = getCurrentCompletedQuizTotal(questions)

  const totalCompletedParts = getCurrentCompletedQuestions(
    questions,
    currentQuestionIndex,
    currentChoiceIndex,
  )

  if (currentQuestionIndex === 0 && currentChoiceIndex === 0) {
    return [1, totalAmount]
  }

  if (totalCompletedParts + 1 > totalAmount) {
    return [totalAmount, totalAmount]
  }

  return [totalCompletedParts + 1, totalAmount]
}
